export default {"src":"/_next/static/media/accident_64.48d1244d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};